/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import mergeRight from 'ramda/src/mergeRight'
import mergeDeepRight from 'ramda/src/mergeDeepRight'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authService: false,
    user: null,
    permission: null,
    farmStore: null,
    jobStore: null,
    mekaStore: null,
    config: {
      defaultDateFormat: 'DD/MM/YYYY'
    },
    masterdata: {},
    modules: {
      task: {
        filter: {}
      },
      hr: {
        staffInfo: {
        }
      }
    },
    filter: {}
  },
  mutations: {
    authServiceReady (state) {
      if (!state.authService) state.authService = true
    },
    setUser (state, user) {
      state.user = user
    },
    setConfig (state, newValue) {
      state.config = newValue
    },
    setPermission (state, newValue) {
      state.permission = newValue
    },
    setFarm (state, newValue) {
      state.farmStore = newValue
    },
    setMeka (state, newValue) {
      state.mekaStore = newValue
    },
    setJobs (state, newValue) {
      state.jobStore = newValue
    },
    setMasterData (state, newValue) {
      state.masterdata = mergeRight(state.masterdata, newValue)
    },
    setTaskState(state, newValue) {
      state.modules.task = mergeDeepRight(state.modules.task, newValue)
    },
    setHRState(state, newValue) {
      state.modules.hr = mergeDeepRight(state.modules.hr, newValue)
    },
    setFilter(state, newValue) {
      state.filter = mergeRight(state.filter, newValue)
    }
  },
  actions: {
    registerUser ({ commit, state }, user) {
      commit('authServiceReady')
      commit('setUser', user)
    },
    registerPermission ({ commit, state }, permission) {
      commit('setPermission', permission)
    },
    registerFarm ({ commit, state }, farmStore) {
      commit('setFarm', farmStore)
    },
    registerJobs ({ commit, state }, jobStore) {
      commit('setJobs', jobStore)
    },
    registerMeka ({ commit, state }, mekaStore) {
      commit('setMeka', mekaStore)
    },
    registerTaskMasterData ({ commit }, taskMasterData) {
      commit('setMasterData', { taskMasterData: taskMasterData })
    },
    registerTaskState({ commit }, data) {
      commit('setTaskState', data)
    },
    registerHRState({ commit }, data) {
      commit('setHRState', data)
    },
    registerFilterState({ commit }, data) {
      commit('setFilter', data)
    }
  },
  getters: {
    isAnonymous: state => {
      return state.authService && !state.user
    },
    user: state => {
      return state.user
    },
    permission: state => {
      return state.permission
    },
    farmStore: state => {
      return state.farmStore
    },
    mekaStore: state => {
      return state.mekaStore
    },
    jobStore: state => {
      return state.jobStore
    },
    taskState: state => {
      return state.modules.task
    },
    hr: state => {
      return state.modules.hr
    },
    filter: state => {
      return state.filter
    }
  }
})
